import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import useScrollToTop from '../hooks/useScrollToTop'
import NoData from '../component/NoData'
import DOMPurify from "dompurify";
import { parseSafeHtml } from "../utils/safeHtmlParser";

const Terms = () => {
  useScrollToTop()
  const[isTermsData,setIsTermsData]=useState([])
  const[isNoData,setIsNoData]=useState(false)
  const[loading, setLoading] = useState(true);
  //USEEFFECT
  useEffect(()=>{
      const termsDataFetch = async ()=>{
            
        try {
            const token = localStorage.getItem('access_token');
            const responseTerms = await OtherService.termsCondition(token);
           
            if(responseTerms.error == false && responseTerms.data.content_banner_details_contact.content_spot_contents.length > 0 )
            {
              setIsTermsData(responseTerms.data.content_banner_details_contact.content_spot_contents);
              setLoading(false);
              setIsNoData(false);
            }
            else{
              setLoading(false);
              setIsNoData(true);
            }
            
            
           }
            catch(e){
              console.error("e")
            }
           
          }
      termsDataFetch()
  },[])
  return (
    <>
    {loading && <Loader/> }
   
    <BreadCrumbSecttion
     pageTitle="Terms & Condition"
     currentPageName="Terms & Condition"/>
    
    <section className='padTop50'>
       <div className="dashboard-details">
        <Container>
          <Row>
                <Col xs={12}>
                    <section className='padTop50'>
                     {isNoData &&  <NoData />}
                      {!isNoData && 
                        <div className="userInfoBox">
                          {isTermsData?.map((item,index)=>{
                            const{content_map_id,article_detail,article_text}=item
                            return(
                              <div key={content_map_id}>
                                   <h2 className='articleTitle gradient-text'>{article_text}</h2>
                                   {/* <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(article_detail)}} className='mb-4'>
                                   </div> */}
                                    <div>
                                      {parseSafeHtml(article_detail)}
                                    </div>
                              </div>
                            )
                          })}
                        </div>
}                     
                    </section>
                </Col>
            </Row>
            </Container>
       </div>
    </section>
   
    </>
  )
}

export default Terms